import { HttpClient as AngularHttpClient } from '@angular/common/http';
import { serializeQuery } from '@api/client/flattenObject';
import { ContentType, HttpClient, Request } from '@api/model/my-api';
import { Observable } from 'rxjs';
import { environment } from '../../envs/env';

const getResponseType = (request: Request): any => {
  // @ts-ignore
  return request?.file ? 'blob' : 'json';
};

const prepareBody = (obj: any, type: string): any => {
  if (type === ContentType.FormData) {
    const formData = new FormData();
    formData.append('file', obj.file);

    return formData;
  }

  return obj;
};

export const angularApiHttpClient = (client: AngularHttpClient): HttpClient => {
  return {
    request: <D>(req: Request): Observable<D> => {
      let fullPath = req.path;
      if (!req.path.startsWith('http')) {
        fullPath = environment.apiUrl + req.path;
      }
      return client.request<D>(req.method, fullPath, {
        params: serializeQuery(req.query),
        body: prepareBody(req.body, req.type ?? ''),
        responseType: getResponseType(req),
        context: req.context,
      });
    },
  };
};
